import React from 'react'

import { Wrapper } from './styles'

/**
 *
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'url' implicitly has an 'any' type.
function getUrlExtension(url) {
  return url ? url.split(/[#?]/)[0].split('.').pop().trim() : null
}

// @ts-expect-error TS(7006) FIXME: Parameter 'type' implicitly has an 'any' type.
function getComponentForType(type) {
  switch (type) {
    case 'gif':
    case 'png':
    case 'jpg':
      return ImageAttachment
    case 'mp4':
    case 'ogg':
      return VideoAttachment
    default:
      return OtherAttachment
  }
}

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'type' implicitly has an 'any' typ... Remove this comment to see the full error message
const Attachment = ({ type, url }) => {
  const urlExtension = getUrlExtension(url)

  const Component = getComponentForType(urlExtension)

  return (
    <Wrapper>
      <Component type={type} url={url} />
    </Wrapper>
  )
}

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'url' implicitly has an 'any' type... Remove this comment to see the full error message
const ImageAttachment = ({ url }) => <img src={url} alt="" />

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'type' implicitly has an 'any' typ... Remove this comment to see the full error message
const VideoAttachment = ({ type, url }) => (
  <video
    controls={type === 'video_inline'}
    autoPlay={type === 'animated_image_share'}
    muted
    loop
  >
    <source src={url} type="video/mp4" />
  </video>
)

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'url' implicitly has an 'any' type... Remove this comment to see the full error message
const OtherAttachment = ({ url }) => null

export default Attachment
